// extracted by mini-css-extract-plugin
export default {"categoryList":"Service_categoryList__K567b"};